/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { isModel, TGenericModelNode } from "@adapptio/lib-blueprint";
import { TInspectorNode } from "./InspectorNodeTypes";
import { getModelMapper } from "./mappers";
import { isFunction } from "@adapptio/lib-shared";
import { createDefaultNode } from "./createDefaultNode";
import { isHidden } from "./utils";

export function mapModelToNodes(model: TGenericModelNode): TInspectorNode {
	if (!isModel(model) || isHidden(model)) {
		return null;
	}

	const mapper = getModelMapper(model);

	if (isFunction(mapper)) {
		return mapper(model);
	}

	return createDefaultNode({ key: model.schema._id });
}
